import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import Footer from "../pages/Footer";

export function Layout({ children, navLinks }: { children: React.ReactNode; navLinks: { path: string; label: string }[] }) {
  const [activeSection, setActiveSection] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      for (const link of navLinks) {
        const id = link.path.replace("#", "");
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 150 && rect.bottom >= 150) {
            setActiveSection(id);
            break;
          }
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [navLinks]);

  return (
    <div className="min-h-screen flex flex-col">
      <header className="fixed top-0 left-0 right-0 z-50 bg-zinc-950/80 backdrop-blur-md border-b border-zinc-800">
        <nav className="max-w-4xl mx-auto px-4 md:px-6 py-4 flex justify-between items-center">
          <a href="/#home" className="text-xl font-bold text-cyan-400">
            Theacebutler
          </a>
          <ul className="hidden md:flex gap-6">
            {navLinks.map((link) => {
              const id = link.path.replace("#", "");
              return (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className={`transition-colors duration-200 ${activeSection === id
                      ? "text-cyan-400"
                      : "text-zinc-400 hover:text-zinc-100"
                      }`}
                  >
                    {link.label}
                  </Link>
                </li>
              );
            })}
          </ul>
          <button
            className="md:hidden text-zinc-400 hover:text-zinc-100"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
          </button>
        </nav>
        <div className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${isMenuOpen ? "max-h-64 opacity-100" : "max-h-0 opacity-0"}`}>
          <ul className="px-4 pb-4 space-y-3">
            {navLinks.map((link) => {
              const id = link.path.replace("#", "");
              return (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    onClick={() => setIsMenuOpen(false)}
                    className={`block transition-colors duration-200 ${activeSection === id
                      ? "text-cyan-400"
                      : "text-zinc-400 hover:text-zinc-100"
                      }`}
                  >
                    {link.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </header>
      <main className="flex-1 pt-20 pb-16">{children}</main>
      <Footer />
    </div>
  );
}
